import React, { useEffect, useState } from 'react'
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog';
import { EventAPI } from '../../../api/EventAPI';
import { useSelector } from 'react-redux';
import CustomContainerLoader from '../../CustomComponents/CustomContainerLoader/CustomContainerLoader';
import { Accordion, AccordionDetails, AccordionSummary, Radio, Step, StepConnector, StepLabel, Stepper, styled, Typography } from '@mui/material';
import CustomCheckbox from '../../CustomComponents/CustomCheckbox/CustomCheckbox';
import { BiDollar } from 'react-icons/bi';
import payStyles from '../../../styles/modules/RegistrationSetup.module.css';
import styles from '../../../styles/modules/ChildProfile.module.css';
import { getLogoByPaymentMethodName } from '../../../util/PaymentUtil';
import { PaymentAPI } from '../../../api/PaymentAPI';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import CustomSwitch from '../../CustomComponents/CustomSwitch/CustomSwitch.jsx'



const rootStyle = getComputedStyle(document.documentElement);
const color = rootStyle.getPropertyValue("--hoverColorBold").trim();

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    "& .MuiStepConnector-line": {
        borderColor: color, // Change connector line color
    },
}));
const radioBtnStyle = {
    '&.Mui-checked': {
        color: 'var(--hoverColorBold)', // checked color
    },
    '&.Mui-checked ~ .MuiFormControlLabel-label': {
        color: 'var(--hoverColorBold)',
    },
};
const AddPlanDialog = ({ openFeePopup, existingFeeList, setOpenFeePopup, eventId, isPlayer, playerId, setIsLoading, isPlanReplaceable = true }) => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const userInfo = useSelector((store) => store.user.userInfo);
    const [popupLoader, setPopupLoader] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState({});
    const [feeDetails, setFeeDetails] = useState({})
    const [feeList, setFeeList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [paymentMethods, setPaymentMethods] = useState({ offline_payment: [], online_payment: [] });
    const [isReplacePlan, setIsReplacePlan] = useState(false);
    const [replaceablePlan, setReplaceablePlan] = useState([])
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let steps = [];
    if (isPlanReplaceable) {
        steps = [
            {
                label: 'Participant Fee',
                step: 0
            },
            {
                label: 'Plan Replace',
                step: 1
            },
            {
                label: 'Checkout',
                step: 2
            },
            {
                label: 'Payment Method',
                step: 3
            }
        ]
    } else {
        steps = [
            {
                label: 'Participant Fee',
                step: 0
            },
            {
                label: 'Checkout',
                step: 1
            },
            {
                label: 'Payment Method',
                step: 2
            }
        ]
    }
    const getEventParticipantFees = async () => {
        try {
            setPopupLoader(true);
            const response = await EventAPI.getEventParticipantFees(eventId);
            setFeeList(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setPopupLoader(false);
        }
    };
    const getEventPaymentMethods = async () => {
        try {
            const response = await EventAPI.getEventPaymentMethods(eventId);
            setPaymentMethods({
                online_payment: response.Data.onlinePaymentMethods,
                offline_payment: response.Data.offlinePaymentMethods
            });
        } catch (error) {
            console.log(error);
        } finally {

        }
    };
    useEffect(() => {
        getEventParticipantFees();
        getEventPaymentMethods();
    }, []);
    const handleOnChange = (participantFee, val) => {
        setFeeDetails((prev) => {
            let newList = [...prev];
            if (val && !newList.some(item => item.id === participantFee.id)) {
                newList.push(participantFee);
            } else {
                newList = newList.filter(item => item.id !== participantFee.id)
            }
            return newList;
        })

    };
    const handleReplaceablePlanCollect = (participantFee, val) => {
        setReplaceablePlan((prev) => {
            let newList = [...prev];
            if (val && !newList.some(item => item.id === participantFee.id)) {
                newList.push(participantFee);
            } else {
                newList = newList.filter(item => item.id !== participantFee.id)
            }
            return newList;
        })

    };

    const handlePayment = async () => {
        try {
            const payReqObject = {
                amount: totalAmount,
                userId: userInfo.userId,
                clubId: selectedClub.clubId,
                eventId: eventId,
                isPlayer: isPlayer,
                childId: playerId,
                paymentMethodId: paymentMethod.id,
                participantFees: [feeDetails],
                replaceableFees: replaceablePlan,
                isReplaceablePlan: isReplacePlan && replaceablePlan.length > 0
            }
            setIsLoading(true)
            const response = await PaymentAPI.postCreatePaymentIntentForGuardianPayEvent(payReqObject);
            navigate("/event-checkout", {
                replace: true,
                state: {
                    clientSecret: response.Data.paymentIntentClientSecret,
                    paymentIntentId: response.Data.paymentIntentId,
                    totalAmount: response.Data.totalAmount,
                    processingFee: response.Data.processingFee,
                    feeDetails: [feeDetails],
                    replaceablePlan: replaceablePlan
                }
            });
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleOfflinePayment = async () => {
        try {

            const payReqObject = {
                participantFees: [feeDetails],
                userId: userInfo.userId,
                clubId: selectedClub.clubId,
                eventId: eventId,
                isPlayer: isPlayer,
                childId: playerId,
                paymentMethodId: paymentMethod.id,
                replaceableFees: replaceablePlan,
                amount: totalAmount,
                isReplaceablePlan: isReplacePlan && replaceablePlan.length > 0
            }
            setIsLoading(true)
            const response = await PaymentAPI.postGuardianOfflinePaymentForSeason(payReqObject);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'info', content: 'Registration request sent. Please complete your offline payment using the provided details.' }))
            navigate("/", { replace: true })
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleFreeEventregistration = async () => {
        try {

            const payReqObject = {
                participantFees: [feeDetails],
                userId: userInfo.userId,
                eventId: eventId,
                isPlayer: isPlayer,
                childId: playerId,
                replaceableFees: replaceablePlan
            }
            setIsLoading(true)
            const response = await PaymentAPI.postProcessFreeEvent(payReqObject);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Registration Sucessfully done.' }))
            navigate("/", { replace: true })
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    let grossAmount = feeDetails?.feeAmount ?? 0;
    let totalExistFeeAmount = replaceablePlan.reduce((sum, curr) => sum + parseFloat(curr.feeAmount), 0);
    let totalAmount = grossAmount - totalExistFeeAmount;
    const submitButtonName = () => {
        if(totalAmount === 0){
            return 'Submit'
        }
        if (activeTab === 0 || (activeTab === 1) || (activeTab === 2 && isPlanReplaceable)) {
            return 'Next';
        } else {
            if (paymentMethod.type === "offline_payment" || totalAmount === 0) {
                return 'Submit';
            } else {
                return 'Pay'
            }
        }
    };
    const newFeeList = feeList?.filter(pp => !existingFeeList.some(ep => ep.id === pp.id)) ?? [];

    return (
        <CustomDialog
            isOpen={openFeePopup}
            onCancel={() => {
                if (activeTab === 0) {
                    setOpenFeePopup(false);
                    setTimeout(() => {
                        setActiveTab(0)
                        setFeeDetails([]);
                        setPaymentMethod({});
                        setReplaceablePlan([])
                        setIsReplacePlan(false);
                    }, 300);
                } else if (activeTab === 1) {
                    setActiveTab(0)
                }
                else if (activeTab === 2) {
                    setActiveTab(1)
                }
                else if (activeTab === 3) {
                    setActiveTab(2)
                }
            }}
            onClose={() => setOpenFeePopup(false)}
            submitBtnName={submitButtonName()}
            cancelBtnName={activeTab === 0 ? 'Cancel' : 'Back'}
            hideSubmitBtn={totalAmount < 0 && ((!isPlanReplaceable && activeTab === 1) || (isPlanReplaceable && activeTab === 2))}
            onSubmit={() => {
                if (totalAmount < 0 && ((!isPlanReplaceable && activeTab === 1) || (isPlanReplaceable && activeTab === 2))) {
                    return;
                }
                if (totalAmount === 0) {
                    handleFreeEventregistration();
                } else if (activeTab === 0) {
                    if (feeDetails.length === 0) {

                    } else {
                        setActiveTab(1);
                    }
                } else if ((isPlanReplaceable && activeTab === 1) || (!isPlanReplaceable && activeTab === 1)) {
                    setActiveTab(2);
                } else if (isPlanReplaceable && activeTab === 2) {
                    setActiveTab(3);
                } else {
                    if (paymentMethod.type === 'online_payment' && totalAmount !== 0) {
                        handlePayment();
                        //console.log("fee details ?? ", feeDetails);
                    }
                    if (paymentMethod.type === 'offline_payment') {
                        handleOfflinePayment();
                       // console.log("fee details ?? ", feeDetails);
                    }
                }
            }}
        >
            {popupLoader ?
                <div style={{ height: '40dvh', width: '50vw' }}>
                    <CustomContainerLoader />
                </div>
                :
                <>
                    <Stepper
                        activeStep={activeTab}
                        connector={<CustomStepConnector />}
                        alternativeLabel
                    >
                        {steps?.map((data, index) => (
                            <Step key={data.step}>
                                <StepLabel

                                    StepIconProps={{
                                        sx: {
                                            color: (theme) =>
                                                activeTab === index
                                                    ? 'var(--hoverColorBold)'
                                                    : theme.palette.text.disabled,
                                            '&.Mui-active': {
                                                color: 'var(--hoverColorBold)',
                                            },
                                            '&.Mui-completed': {
                                                color: 'var(--hoverColorBold)',
                                            },
                                        },
                                    }}
                                >{data.label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeTab === 0 &&
                        <div className='sm_event_add_fee_container'>
                            {newFeeList?.map((fee) =>
                                <div className='sm_event_add_fee_card'>
                                    {/* <CustomCheckbox checked={feeDetails?.some(item => item.id === fee.id)} onChange={(event) => handleOnChange(fee, event.target.checked)} /> */}
                                    <Radio onClick={() => setFeeDetails(fee)} checked={fee.id === feeDetails.id} sx={radioBtnStyle} />
                                    <div className='sm_event_add_fee_desc'>
                                        <h3>{fee?.criteria}</h3>
                                        <p>{fee?.description}</p>
                                    </div>
                                    <h3 className='sm_event_add_fee_price'><BiDollar className='sm_event_add_fee_icon' />{Number(fee?.feeAmount).toFixed(2)}</h3>
                                </div>)}
                        </div>}
                    {(isPlanReplaceable && activeTab === 1) &&
                        <div className='sm_player_replace_plan_con'>
                            <div className='sm_player_replace_plan_switch'>
                                <p>Do you want to replace the existing plan with this one?</p>
                                <CustomSwitch checked={isReplacePlan} onChange={(e) => setIsReplacePlan(e.target.checked)} />
                            </div>
                            {isReplacePlan &&
                                <div className='sm_event_add_fee_container'>
                                    {existingFeeList?.map((fee) =>
                                        <div className='sm_event_add_fee_card'>
                                            <CustomCheckbox checked={replaceablePlan?.some(item => item.id === fee.id)} onChange={(event) => handleReplaceablePlanCollect(fee, event.target.checked)} />
                                            <div className='sm_event_add_fee_desc'>
                                                <h3>{fee?.criteria}</h3>
                                                <p>{fee?.description}</p>
                                            </div>
                                            <h3 className='sm_event_add_fee_price'><BiDollar className='sm_event_add_fee_icon' />{Number(fee?.feeAmount).toFixed(2)}</h3>
                                        </div>)}
                                </div>}
                        </div>
                    }
                    {((!isPlanReplaceable && activeTab === 1) || (isPlanReplaceable && activeTab === 2)) &&
                        <div className='sm_player_schekout_plan_con'>
                            <h3>New Participant Fee</h3>
                            <div className='sm_player_schekout_plan_desc'>
                                <p>{feeDetails?.criteria}</p>
                                <h4>${Number(feeDetails?.feeAmount).toFixed(2)}</h4>
                            </div>
                            {replaceablePlan?.length !== 0 &&
                                <>
                                    <h3>Replaced Participant Fee</h3>
                                    {replaceablePlan?.map((fee) =>
                                        <div className='sm_player_schekout_plan_desc'>
                                            <p>{fee?.criteria}</p>
                                            <h4>-${Number(fee?.feeAmount).toFixed(2)}</h4>
                                        </div>)}
                                </>}
                            <hr />
                            <div className='sm_player_schekout_plan_desc'>
                                <p>Gross Amount</p>
                                <h4>${totalAmount?.toFixed(2)}</h4>
                            </div>
                            {totalAmount < 0 && <h4>The total amount cannot be negative. Please review your selected plans or fees before proceeding with the payment.</h4>}
                        </div>}

                    {((!isPlanReplaceable && activeTab === 2) || (isPlanReplaceable && activeTab === 3)) &&
                        <div style={{ maxWidth: '500px' }}>
                            <div className={payStyles['form_payment_method_list']}>
                                {
                                    Object.entries(paymentMethods)?.map(([key, value]) =>
                                        <React.Fragment key={key}>
                                            {((key === 'online_payment' && value.length != 0) || (key === 'offline_payment' && value.length != 0)) &&
                                                <div className={payStyles['form_payment_method_card']}>
                                                    <Radio sx={radioBtnStyle} disabled={totalAmount === 0} checked={paymentMethod?.type === key} onChange={(e) => setPaymentMethod({ id: value.id, type: key })} />
                                                    <p className={totalAmount === 0 ? `${payStyles['form_payment_method_title']} ${styles['disabled']}` : styles['form_payment_method_title']}>{key?.replaceAll("_", " ")}</p>
                                                </div>}
                                            {paymentMethod?.type == key &&
                                                <div className={payStyles['online_payment_method_list']}>
                                                    {value?.map((pm, index) =>
                                                        <Accordion
                                                            expanded={pm.id === paymentMethod.id}
                                                            elevation={0}
                                                            sx={{
                                                                boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
                                                                borderRadius: '15px',
                                                                height: 'max-content',
                                                                minHeight: 0,
                                                                margin: 0,
                                                                padding: 0,
                                                                '&.Mui-expanded': {
                                                                    minHeight: 0,
                                                                    margin: 0
                                                                },
                                                            }}

                                                        >
                                                            <AccordionSummary
                                                                aria-controls="panel1-content"
                                                                id="panel1-header"

                                                            >

                                                                <div key={index} className={payStyles['online_payment_method_card']}>
                                                                    <div key={index} className={payStyles['online_payment_method_card_heading']}>
                                                                        <img src={getLogoByPaymentMethodName(pm?.paymentMethodName?.replaceAll("_", " "))} alt="credit card" />
                                                                        <h4>{pm?.paymentMethodName?.replaceAll("_", " ")}</h4>
                                                                    </div>
                                                                    <Radio sx={radioBtnStyle} checked={pm.id === paymentMethod.id} onChange={() => setPaymentMethod({ ...paymentMethod, id: pm.id, name: pm.paymentMethodName })} />
                                                                </div>
                                                            </AccordionSummary>
                                                            {pm?.payMethodDesc &&
                                                                <AccordionDetails>
                                                                    <Typography>
                                                                        {pm?.payMethodDesc}
                                                                    </Typography>
                                                                </AccordionDetails>}
                                                        </Accordion>)}
                                                </div>}
                                        </React.Fragment>
                                    )
                                }
                            </div>
                        </div>}
                </>
            }
        </CustomDialog>
    )
}

export default AddPlanDialog